/* eslint-disable camelcase */
// remove after api integration
import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const DropdownOption = () => ({
    surgery_time: [
        t('scheduleSurgery.details.surgeryTime.time1'),
        t('scheduleSurgery.details.surgeryTime.time2'),
        t('scheduleSurgery.details.surgeryTime.time3'),
        t('scheduleSurgery.details.surgeryTime.time4'),
        t('scheduleSurgery.details.surgeryTime.time5'),
        t('scheduleSurgery.details.surgeryTime.time6'),
        t('scheduleSurgery.details.surgeryTime.time7'),
        t('scheduleSurgery.details.surgeryTime.time8'),
        t('scheduleSurgery.details.surgeryTime.time9'),
        t('scheduleSurgery.details.surgeryTime.time10'),
        t('scheduleSurgery.details.surgeryTime.time11'),
        t('scheduleSurgery.details.surgeryTime.time12'),
        t('scheduleSurgery.details.surgeryTime.time13'),
        t('scheduleSurgery.details.surgeryTime.time14'),
        t('scheduleSurgery.details.surgeryTime.time15'),
        t('scheduleSurgery.details.surgeryTime.time16'),
        t('scheduleSurgery.details.surgeryTime.time17'),
        t('scheduleSurgery.details.surgeryTime.time18'),
        t('scheduleSurgery.details.surgeryTime.time19'),
        t('scheduleSurgery.details.surgeryTime.time20'),
        t('scheduleSurgery.details.surgeryTime.time21'),
        t('scheduleSurgery.details.surgeryTime.time22'),
        t('scheduleSurgery.details.surgeryTime.time23'),
        t('scheduleSurgery.details.surgeryTime.time24'),
    ],

    duration: [
        {
            id: '1:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration1'),
        },
        {
            id: '1:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration2'),
        },
        {
            id: '2:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration3'),
        },
        {
            id: '2:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration4'),
        },
        {
            id: '3:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration5'),
        },
        {
            id: '3:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration6'),
        },
        {
            id: '4:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration7'),
        },
        {
            id: '4:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration8'),
        },
        {
            id: '5:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration9'),
        },
        {
            id: '5:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration10'),
        },
        {
            id: '6:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration11'),
        },
        {
            id: '6:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration12'),
        },
        {
            id: '7:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration13'),
        },
        {
            id: '7:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration14'),
        },
        {
            id: '8:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration15'),
        },
        {
            id: '8:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration16'),
        },
        {
            id: '9:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration17'),
        },
        {
            id: '9:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration1'),
        },
        {
            id: '10:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration19'),
        },
        {
            id: '10:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration20'),
        },
        {
            id: '11:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration21'),
        },
        {
            id: '11:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration22'),
        },
        {
            id: '12:00:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration23'),
        },
        {
            id: '12:30:00',
            label: i18n.t('scheduleSurgery.details.surgeryDuration.duration24'),
        },
    ],
    numberOfSurgery: [1, 2, 3, 4],
});
